import type { Variants } from "framer-motion";
import { DURATION, EASE, SPRING } from "./tokens";

export const fadeIn: Variants = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { duration: DURATION.base, ease: EASE.out } },
    exit: { opacity: 0, transition: { duration: DURATION.fast } }
};

export const fadeUp = (y = 10): Variants => ({
    hidden: { opacity: 0, y },
    show: { opacity: 1, y: 0, transition: { duration: DURATION.base, ease: EASE.out } },
    exit: { opacity: 0, y: y / 2, transition: { duration: DURATION.fast } }
});

export const pop: Variants = {
    hidden: { opacity: 0, scale: 0.6 },
    show: { opacity: 1, scale: 1, transition: SPRING.bouncy },
    exit: { opacity: 0, scale: 0.8, transition: { duration: DURATION.fast } }
};

export const scaleFade: Variants = {
    hidden: { opacity: 0, scale: 0.96 },
    show: { opacity: 1, scale: 1, transition: { duration: DURATION.base, ease: EASE.out } },
    exit: { opacity: 0, scale: 0.98, transition: { duration: DURATION.fast } }
};

export const sheetUp: Variants = {
    hidden: { y: "100%" },
    show: { y: 0, transition: { duration: 0.3, ease: EASE.sheet } },
    exit: { y: "100%", transition: { duration: 0.22, ease: EASE.inOut } }
};

export const backdrop: Variants = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { duration: 0.2 } },
    exit: { opacity: 0, transition: { duration: 0.2 } }
};

export const shake = {
    x: [0, -6, 6, -4, 4, 0],
    transition: { duration: 0.4, ease: "easeInOut" }
} as const;

export const staggerContainer = (stagger = 0.06, delayChildren = 0): Variants => ({
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren } },
    exit: {}
});
